/**
 * Card container component from shadcn/ui.
 *
 * Composed from Card, CardHeader, CardTitle, and CardContent sub-components.
 * Uses semantic color tokens (bg-card, text-card-foreground) so it adapts
 * to light and dark themes automatically without conditional logic.
 *
 * Used by the dashboard service grid and any feature showing grouped data.
 */
import { cn } from "../utils/cn/mergeClassNames";

function Card({ className, warm, ...props }: React.HTMLAttributes<HTMLDivElement> & { warm?: boolean }) {
  return (
    <div
      className={cn(
        "rounded-xl border bg-card text-card-foreground p-4",
        warm ? "border-warm-border bg-warm-mist" : "border-border",
        className
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex flex-col gap-1.5 p-4", className)} {...props} />;
}

function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn("text-sm font-medium", className)} {...props} />;
}

function CardContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4 pt-0", className)} {...props} />;
}

export { Card, CardHeader, CardTitle, CardContent };
